
export const TRANSCRIPT_REFSEQ_XENO_QUERY = `
query Gene($coordinates: GenomicRangeInput, $assembly: String!) {
  refseqxenogenes(assembly: $assembly, coordinates: $coordinates) {
    strand,
    transcripts {
      coordinates {
        start,
        end
      },
      name,
      id,
      exons {
        coordinates {
          start,
          end
        },
        UTRs {
          coordinates {
            start,
            end
          }
        }
      }
    }
  }
}
`;


export const TRANSCRIPT_REFSEQ_QUERY = `
query Gene($coordinates: GenomicRangeInput, $assembly: String!) {
    refseqgenes(assembly: $assembly, coordinates: $coordinates) {
      strand,
      transcripts {
        coordinates {
          start,
          end
        },
        name,
        id,
        exons {
          coordinates {
            start,
            end
          },
          UTRs {
            coordinates {
              start,
              end
            }
          }
        }
      }
    }
  }
`;

export const TRANSCRIPT_GENES_QUERY = `
query Gene($chromosome: String, $assembly: String!, $start: Int, $end: Int) {
    gene(assembly: $assembly, chromosome: $chromosome, start: $start, end: $end) {
        strand
        name
        id
        transcripts {
            coordinates {
                start
                end
            }
            name
            id
            exons {
                coordinates {
                    start
                    end
                }
                UTRs {
                    coordinates {
                        start
                        end
                    }
                }
            }
        }
    }
}
`;
